"use client"

import dynamic from 'next/dynamic'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material'
import { theme } from '@biolumina/ui/theme/index'
import { GlobalStateProvider } from '@biolumina/ui/context/globalStateProvider'
import { useSite } from '@/data/site'
import { useEffect } from 'react'

// Defer non-critical UI out of the initial JS bundle — none are needed for first paint.
const TrustedExternalModal = dynamic(() => import('@biolumina/ui/containers/modals/trustedExternalModal').then(m => ({ default: m.TrustedExternalModal })), { ssr: false })
const UntrustedExternalModal = dynamic(() => import('@biolumina/ui/containers/modals/untrustedExternalModal').then(m => ({ default: m.UntrustedExternalModal })), { ssr: false })
const BackToTop = dynamic(() => import('@biolumina/ui/components/backToTop/backToTop').then(m => ({ default: m.BackToTop })), { ssr: false })

export function ClientLayout({ children }) {
  const siteData = useSite()

  // Recover from stale chunk references after a deploy (e.g. a page
  // rename that invalidates old _next/static chunk hashes). Without
  // this, a ChunkLoadError crashes to the generic Next.js error screen.
  useEffect(() => {
    const handleChunkError = (event) => {
      const isChunkError =
        event?.error?.name === 'ChunkLoadError' ||
        /Loading chunk \d+ failed/.test(event?.message || '')

      if (isChunkError) {
        window.location.reload()
      }
    }

    window.addEventListener('error', handleChunkError)
    return () => window.removeEventListener('error', handleChunkError)
  }, [])

  return (
    <GlobalStateProvider siteData={siteData}>
      <ThemeProvider theme={theme}>
        <CssBaseline enableColorScheme />
        <TrustedExternalModal />
        <UntrustedExternalModal />
        <BackToTop />
        {children}
      </ThemeProvider>
    </GlobalStateProvider>
  )
}